"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as d } from "./tv.config-BuYIgndg.mjs";
import t from "./Typography.js";
const c = d({
  base: ["Card__Header p-5"],
  variants: {}
}), h = (e) => {
  const {
    className: n,
    component: o = "div",
    heading: s,
    subHeading: r,
    ...i
  } = e;
  return /* @__PURE__ */ a.jsxs(o, { ...i, className: c({ class: n }), children: [
    !!s && /* @__PURE__ */ a.jsx(t, { variant: "h3", children: s }),
    !!r && /* @__PURE__ */ a.jsx(t, { variant: "subtitle1", children: r }),
    e.children
  ] });
};
export {
  h as default
};
